// File for logic corresponding to statistic component

import { Component } from 'js-component-framework';
import CountUp from 'countup.js';

/**
 * Component for a statistic rendered via the [stat] shortcode.
 */
export default class Statistic extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    this.initCountUpTargets();
  }

  /**
   * Initialize any found CountUp-eligible stats.
   *
   * @todo Make Counter component instead.
   */
  initCountUpTargets() {
    Array.prototype.forEach.call(
      this.children.countUpTargets,
      Statistic.initCountUp
    );
  }

  /**
   * Initialize CountUp in an element.
   *
   * @param {Element} target Element with a CountUp config attribute.
   */
  static initCountUp(target) {
    const config = JSON.parse(target.dataset.countup);

    const instance = new CountUp(
      target,
      config.start,
      config.end,
      config.decimals,
      config.duration,
      {
        separator: config.separator,
        decimal: config.decimal,
        // These are assumed.
        useEasing: true,
        useGrouping: true,
      }
    );

    // "Is element fully visible" and "is element visible at all" don't quite have
    // the right effect. The goal is to start the counter when most of the initial
    // "0" is visible so the start of the spinning is noticeable but the "0"
    // doesn't make an impression.
    const isVisibleEnough = (element) => {
      const rect = element.getBoundingClientRect();

      return (
        0 < rect.top
        && (rect.top + (rect.height * 0.75) <= window.innerHeight)
      );
    };

    const startIfVisible = () => {
      if (isVisibleEnough(target)) {
        instance.start();
        window.removeEventListener('scroll', startIfVisible);
      }
    };

    window.addEventListener('scroll', startIfVisible);
    startIfVisible();
  }
}



// WEBPACK FOOTER //
// ./client/src/components/statistic/statistic.js